import axios from "axios";
import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../enum/constant";

const UpdatePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const modal = document.getElementById("passwordModal");

    modal.addEventListener("shown.bs.modal", () => {
      clearValues();
    });
  }, []);

  const clearValues = () => {
    setError("");
    setSuccess("");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setShowCurrentPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("The new password and confirmation does not match.");
      return;
    }

    const data = {
      current_password: currentPassword,
      new_password: newPassword,
      new_password_confirmation: confirmPassword,
    };

    try {
      const token = localStorage.getItem("token");
      const base = baseUrl;
      const response = await axios.post(base + "api/update-password", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setSuccess(response.data.message);

      setTimeout(() => {
        clearValues();
      }, 3000);
    } catch (error) {
      if (error.response) {
        setError(
          error.response.data.error ||
            error.response.data.message ||
            "An error occurred"
        );
      } else {
        setError("Network error");
      }
    }
  };

  return (
    <>
      {/* <!-- Password Modal --> */}
      <div className="modal fade" id="passwordModal" tabindex="-1">
        <div className="modal-dialog">
          <div className="modal-content pass-modal-cont p-3">
            <div className="modal-header border-0">
              <h5 className="modal-title">Change Password</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              >
                <img src="assets/images/cross.png" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="mb-3">
                  <div className="box">
                    <label>Current Password</label>
                    <input
                      type={showCurrentPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Enter current password"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      required
                    />
                    {showCurrentPassword ? (
                      <div
                        className="eye-div"
                        onClick={() =>
                          setShowCurrentPassword(!showCurrentPassword)
                        }
                      >
                        <img
                          className="eye-slash"
                          src="images/new/eye-slash.png"
                        />
                      </div>
                    ) : (
                      <div
                        className="eye-div"
                        onClick={() =>
                          setShowCurrentPassword(!showCurrentPassword)
                        }
                      >
                        <img className="eye" src="images/new/eye.png" />
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <div className="box">
                    <label>New Password</label>
                    <input
                      className="form-control"
                      placeholder="Enter new password"
                      type={showNewPassword ? "text" : "password"}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                    {showNewPassword ? (
                      <div
                        className="eye-div"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      >
                        <img
                          className="eye-slash"
                          src="images/new/eye-slash.png"
                        />
                      </div>
                    ) : (
                      <div
                        className="eye-div"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      >
                        <img className="eye" src="images/new/eye.png" />
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <div className="box">
                    <label>Confirm New Password</label>
                    <input
                      className="form-control"
                      placeholder="Confirm New Password"
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                    {showConfirmPassword ? (
                      <div
                        className="eye-div"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        <img
                          className="eye-slash"
                          src="images/new/eye-slash.png"
                        />
                      </div>
                    ) : (
                      <div
                        className="eye-div"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        <img className="eye" src="images/new/eye.png" />
                      </div>
                    )}
                  </div>
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                {success && (
                  <div className="alert alert-success">{success}</div>
                )}
              </div>
              <div className="modal-footer border-0">
                <button
                  type="submit"
                  className={`btn ${
                    currentPassword && newPassword && confirmPassword
                      ? "btn-primary"
                      : "btn-secondary"
                  }`}
                  disabled={
                    !currentPassword || !newPassword || !confirmPassword
                  }
                >
                  Update
                </button>

                <button
                  type="button"
                  className="btn btn-cancel"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePassword;
